import React, { useEffect, useMemo } from 'react';
import {
  Datagrid,
  TextField,
  useUnselectAll,
  ReferenceField,
  linkToRecord
} from 'react-admin';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';

import StatusSelectField from '../../../core/components/StatusSelectField';
import { fundStatus } from '../../funds/FundLookups';

const styles = () => ({
  table: {
    '& tbody>.MuiTableRow-root:hover': {
      background: 'unset'
    }
  },
  statusColumnStyle: {
    width: '68px'
  },
  label: {
    color: '#424242',
    fontSize: '14px',
    display: 'inline-block',
    paddingBottom: '10px'
  },
  expandLabel: {
    color: '#757575',
    fontSize: '14px',
    display: 'inline-block',
    transform: 'translateY(-10px)'
  },
  progress: {
    display: 'flex',
    justifyContent: 'center'
  },
  editButton: {
    color: '#757575',
    minWidth: '24px',
    padding: '6px 0',
    '& span': {
      paddingRight: 0
    }
  },
  editButtonColumnStyle: {
    width: '24px'
  }
});

const FundFamilyFundDatagrid = props => {
  const {
    handleRowClick,
    classes,
    expand,
    permissions,
    ...datagridProps
  } = props;

  //unselecting all the checkboxes from the deleting actions in the ComponenWillUnmount listener
  const unSelectAll = useUnselectAll(datagridProps.resource);

  useEffect(() => () => unSelectAll(), [unSelectAll]);

  const hasReadFundPermission = useMemo(() => {
    return permissions.includes('AUTH_READ_FUND_NA');
  }, [permissions]);

  if (props.total > 0) {
    return (
      <>
        {expand && <span className={classes.label}>Related Funds</span>}
        <Datagrid {...datagridProps} className={classes.table}>
          <ReferenceField
            source="id"
            reference="funds"
            label="Fund Name"
            link={record =>
              hasReadFundPermission
                ? `${linkToRecord(`/funds`, record.id)}`
                : false
            }
            sortBy="name"
          >
            <TextField source="name" id="fund name" />
          </ReferenceField>
          <TextField label="A.K.A" source="aka" sortable={false} id="aka" />
          <TextField
            source="id"
            label="Fund ID"
            sortable={false}
            id="fund id"
          />
          <TextField
            label="Fund Contact Email"
            source="emailAddresses[0]"
            sortable={false}
            id="fund email"
          />
          <StatusSelectField
            label="Publishing Status"
            source="status"
            choices={fundStatus}
            id="fund status"
            headerClassName={classes.statusColumnStyle}
            cellClassName={classes.statusColumnStyle}
            sortable={false}
          />
        </Datagrid>
      </>
    );
  } else if (props.loaded) {
    return (
      <span className={expand ? classes.expandLabel : classes.label}>
        There are no related Funds to be displayed
      </span>
    );
  } else {
    return (
      <div className={classes.progress}>
        <CircularProgress />
      </div>
    );
  }
};

export default withStyles(styles)(FundFamilyFundDatagrid);
